<section style="display: flex; height: 100%">
  <!-- La lista de viajes y paradas scrollea en su columna; el mapa queda
       fijo al lado -->
  <div
    style="width: 390px; height: 100%; margin-right: 0.5em; overflow-y: auto"
  >
    @if (vehiculo) {
      <app-controles
        [vehiculo]="vehiculo"
        [viajeSelected]="viaje"
        (viajeSelectedChange)="onViajeSelected($event)"
        [paradaSelected]="parada"
        (paradaSelectedChange)="onParadaSelected($event)"
      ></app-controles>
    }
  </div>
  <div style="width: calc(100% - 390px); height: 100%">
    <app-mapa-facil
      [ngStyle]="{ display: mapaReady ? '' : 'none' }"
    ></app-mapa-facil>
    @if (!mapaReady && error) {
      <div class="column-center" style="width: 100%; height: 100%">
        <mat-card>
          <mat-card-content>{{ error }}</mat-card-content>
        </mat-card>
      </div>
    } @else {
      @if (loading) {
        <div class="column-center" style="width: 100%; height: 100%">
          <mat-spinner></mat-spinner>
        </div>
      }
    }
  </div>
</section>
